{
  "cms.contentLocale.label": "Content language",
  "cms.contentLocale.option.fi": "Finnish",
  "cms.contentLocale.option.sv": "Swedish",
  "cms.contentLocale.option.en": "English",
  "cms.contentLocale.openRow.fi": "This content is in Finnish.",
  "cms.contentLocale.openRow.sv": "This content is in Swedish.",
  "cms.contentLocale.openRow.en": "This content is in English.",
  "cms.contentLocale.preview.unavailable": "Preview is not available for this language yet.",
  "cms.contentLocale.preview.empty": "No content has been published in this language yet.",
  "cms.contentLocale.preview.selectedRowEmpty": "This content is not available in the selected language."
}
